import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { colors, fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { H4, H5 } from 'syf-component-library/ui/typography';
import { DCHMessageBox } from '../../../ui/atoms/DCHMessageBox';
export const SettlementTitle = styled(H5) `
  font-weight: ${fontWeights.light};
  font-size: ${fontSizes.medium}px;
`;
export const MessageBoxContainer = styled(DCHMessageBox) `
  padding: ${spacing.base}px ${spacing.xlarge}px;

  @media ${query.greaterThanMedium} {
    padding: ${spacing.large}px ${spacing.xlarge}px;
  }
`;
export const MessageBoxContent = styled.div `
  text-align: center;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  @media ${query.greaterThanMedium} {
    align-items: center;
  }
`;
export const DetailsCard = styled.div `
  background: ${colors.white};
  margin-top: ${spacing.base}px;
  padding: ${spacing.base}px ${spacing.large}px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-row: repeat(2, 1fr);
  gap: ${spacing.base}px;
  border: 2px solid #34657f;
  border-radius: ${spacing.small}px;
  font-size: 14px;
  font-weight: ${fontWeights.regular};

  @media ${query.greaterThanMedium} {
    margin-top: ${spacing.medium}px;
    grid-template-columns: repeat(2, 1fr);
    gap: ${spacing.large}px;
  }
`;
export const DetailsItemAmount = styled.strong `
  font-size: ${fontSizes.root}px;
`;
export const DetailsCardSettlement = styled.div `
  display: flex;
  gap: ${spacing.medium}px;
  text-align: center;
  flex-direction: column;
  align-items: center;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    align-items: left;
  }
`;
export const DetailsCardAmount = styled.div `
  display: flex;
  flex-direction: column;

  > ${H4} {
    color: #34657f;
    font-weight: ${fontWeights.bold};
  }

  @media ${query.greaterThanMedium} {
    > ${H4} {
      text-align: left;
    }
  }
`;
export const DetailsCardPlan = styled.ul `
  display: flex;
  flex-direction: column;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding-left: 0;
  padding-top: ${spacing.base}px;
  border-top: 1px solid #e0e0e0;
  width: 100%;
  text-align: left;

  @media ${query.greaterThanMedium} {
    width: auto;
    padding-top: 0;
    border-top: 0;
    border-left: 1px solid #e0e0e0;
    padding-left: ${spacing.large}px;
  }
`;
export const DetailsCardPlanInfo = styled.span `
  font-size: ${fontSizes.small}px;
`;
export const DetailsInfo = styled.div `
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes.small}px;
  padding-top: ${spacing.base}px;
`;
